import styled from 'styled-components';

export const NewFooterSection = styled.div`
  .bottomImg {
    width: 60%;
    object-fit: unset;
    margin: auto;
    display: block;
    @media (max-width: 720px) {
      visibility: hidden;
      display: none !important;
    }
  }
  .social {
    background: #fff0db;
    padding-top: 3%;
  }
  .footnote {
    padding: 3%;
  }
`;

export const FooterContentSection = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 100px 80px 40px 80px;
  background: #fff0db;
  @media (max-width: 720px) {
    background: #fff1db;
  }
  // background: url("https://images.myloapp.in/NestJsUploads/1697706616725-Subtract.webp");
  // background-repeat: no-repeat;
  // background-position: center;
  // background-size: cover;
  width: 100%;
  .footerLeft {
    img {
      width: 30%;
    }
    flex-basis: 25%;
    .brandTag {
      color: #939393;
      font-size: 20px;
      font-weight: 500;
      padding: 10px 0 14px;
    }
    .brandMsg {
      color: #939393;
      font-size: 14px;
      font-weight: 400;
      line-height: 30px;
    }
    @media (max-width: 720px) {
      text-align: center;
    }
  }
  .footerRight {
    flex-basis: 55%;
    display: flex;
    align-items: baseline;
    column-gap: 80px;
    @media (max-width: 720px) {
      column-gap: 0px;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  @media (max-width: 720px) {
    display: block;
    padding: 20px;
    column-gap: 40px;
    flex-wrap: wrap;
  }
`;

export const FooterBrandSection = styled.div`
  display: block;
  .sectionName {
    color: #23262f;
    font-weight: 500;
    font-size: 16px;
    padding-bottom: 30px;
    @media (max-width: 720px) {
      margin-top: 30px;
      padding-bottom: 10px;
    }
  }
  .linksContainer {
    display: flex;
    flex-direction: column;
    align-items: left;
    a {
      text-decoration: none;
      color: #939393;
      font-size: 14px;
      padding: 8px 0;
      position: relative;
      &:hover {
        color: #555;
      }
    }
  }
`;
